import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "cookie-consent-content" };
const _hoisted_2 = { class: "cookie-consent-header" };
const _hoisted_3 = {
    id: "cookie-consent-title",
    class: "cookie-consent-title"
};
const _hoisted_4 = {
    id: "cookie-consent-description",
    class: "cookie-consent-description"
};
const _hoisted_5 = { class: "cookie-consent-actions" };
import { ref, onUnmounted } from 'vue';
import CockieInfoModal from './CookieInfoModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CookieConsentModal',
    props: {
        visible: { type: Boolean },
        position: { default: 'bottom' },
        autoAcceptDelay: {},
        t: { default: () => ({}) }
    },
    emits: ["accept", "necessary-only"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const countdown = ref(props.autoAcceptDelay);
        const totalCountdown = ref(props.autoAcceptDelay);
        let timer = null;
        const openInfoModal = ref(false);
        const onAccept = () => {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
            emit('accept');
        };
        const onNecessaryOnly = () => {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
            emit('necessary-only');
        };
        onUnmounted(() => {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (__props.visible)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["cookie-consent-modal", { 'cookie-consent-modal--bottom': __props.position === 'bottom' }]),
                                role: "dialog",
                                "aria-labelledby": "cookie-consent-title",
                                "aria-describedby": "cookie-consent-description"
                            }, [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.t?.cookieConsent?.title || 'Cookie Consent'), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_4, [
                                        _createTextVNode(_toDisplayString(__props.t?.cookieConsent?.description || 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content.') + " ", 1),
                                        _createElementVNode("a", {
                                            href: "#",
                                            class: "cookie-info-link",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (openInfoModal.value = true), ["prevent"]))
                                        }, _toDisplayString(__props.t?.cookieConsent?.learnMore || 'Learn more about cookies'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("button", {
                                            class: "cookie-consent-btn cookie-consent-btn--secondary",
                                            onClick: onNecessaryOnly
                                        }, _toDisplayString(__props.t?.cookieConsent?.acceptNecessary || 'Necessary Only'), 1),
                                        _createElementVNode("button", {
                                            class: "cookie-consent-btn cookie-consent-btn--accept",
                                            onClick: onAccept
                                        }, _toDisplayString(__props.t?.cookieConsent?.acceptAll || 'Accept All'), 1)
                                    ])
                                ])
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(CockieInfoModal, {
                    visible: openInfoModal.value,
                    t: __props.t,
                    onClose: _cache[1] || (_cache[1] = ($event) => (openInfoModal.value = false))
                }, null, 8, ["visible", "t"])
            ], 64));
        };
    }
});
